import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import {
  makeStyles,
  Box,
  Grid,
  Typography,
  Link,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@material-ui/core';
import FullLoadingSpinner from '../../../components/FullLoadingSpinner';
import { showAllClaiimSheetAPI } from '../../../apis';
import { YYYYMMDDtoFormat } from '../../../utils'

const useStyles = makeStyles((theme) => ({
  root: {
    '& .page-title-wrapper': {
      marginBottom: 0,
    }
  },
  userInfoTableContainer: {
    marginTop: 60
  }
}))

const ClaimSheet = () => {

  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const history = useHistory();

  const [claimSheets, setClaimSheets] = useState([]);
  const [loading, setLoading] = useState(true);

  let componentMounted = true;
  useEffect(() => {
    showAllClaiimSheetAPI().then(res => {
      if (componentMounted) {
        setLoading(false);
        setClaimSheets([...res.data.data]);
      }
    }).catch(err => {
      if (componentMounted) {
        setLoading(false);
        setClaimSheets([]);
      }
    })
    return () => { componentMounted = false }
  }, [])

  const renderTitle = (title, show_month) => {
    const firstText = title.substr(0, title.indexOf(' '));
    const secondText = title.substr(title.indexOf(' ') + 1, title.length);
    return `${firstText}${YYYYMMDDtoFormat(show_month)}${secondText}`;
  }

  return (
    <Box className={clsx(classes.root, 'main-page-content')}>
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Box className="page-title-wrapper" style={{ marginBottom: 32 }}>
            <Typography variant="h3" className="page-title">
              {t('Claim Sheets')}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box className="darin-table-panel">
            <TableContainer className="darin-table-container">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>{t('title-text')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {claimSheets.map((item, idx) => {
                    return <TableRow key={idx}>
                      <TableCell>
                        <Link
                          onClick={() => { history.push(`/claim-sheet/${item.show_month}/${item.title}`) }}
                          style={{ cursor: 'pointer' }}
                        >
                          {renderTitle(item.title, item.show_month)}
                        </Link>
                      </TableCell>
                    </TableRow>
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Grid>
      </Grid>
      {loading && <FullLoadingSpinner />}
    </Box>
  )
}

export default ClaimSheet;